export const CANCELED_SUB = 'Subscription is Cancelled';
export const PENDING_SUB = 'Subscription is Active';
export const ACCEPTED_SUB = 'Subscription is Active';